type Props = {
  handleEvent: () => void
  setIsOpenModal: (isOpen: boolean) => void
  isLoading: boolean
  title: string
}

export const ExclusionConfirmationMethodModal = ({
  handleEvent,
  setIsOpenModal,
  isLoading,
  title,
}: Props) => {
  return (
    <div
      className={`fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50`}
    >
      <div className="bg-white dark:bg-neutral-800 p-8 rounded-lg max-w-lg">
        <h2 className="text-2xl font-medium text-neutral-900 dark:text-neutral-100 text-center mb-2">
          {title}
        </h2>

        <p className="text-sm text-neutral-600 dark:text-neutral-300 text-center mb-5">
          Esta ação não pode ser desfeita.
        </p>

        <div className="w-full flex items-center justify-center gap-x-10 mt-4">
          <button
            className="bg-neutral-200 text-neutral-900 px-4 py-2 rounded-md w-full hover:opacity-90
            disabled:opacity-50 disabled:cursor-not-allowed
            "
            onClick={() => setIsOpenModal(false)}
            disabled={isLoading}
          >
            Não
          </button>
          <button
            className="bg-red-500 text-white px-4 py-2 rounded-md w-full hover:opacity-90
            disabled:opacity-50 disabled:cursor-not-allowed"
            onClick={handleEvent}
            disabled={isLoading}
          >
            {isLoading ? 'Deletando usuário...' : 'Sim'}
          </button>
        </div>
      </div>
    </div>
  )
}
